import * as React from "react"
import { ConnectNetlifyForm } from "./ConnectNetlifyForm"
import { NewNetlifyIntegrationForm } from "./NewNetlifyIntegrationForm"
import { ExistingNetlifyIntegrationForm } from "./ExistingNetlifyIntegrationForm"
import { CdnIntegration } from "@modules/graphql/types"
import { CdnIntegrationSharedProps } from "@modules/cdn/shared/types"

enum FormState {
  New = `new`,
  Existing = `existing`,
  Connecting = `connecting`,
}

const getInitialStep = (integration: CdnIntegration): FormState => {
  if (integration?.config?.serviceId) {
    return FormState.Existing
  }

  if (integration?.connected) {
    return FormState.New
  }

  return FormState.Connecting
}

export type NetlifyIntegrationWizardProps = CdnIntegrationSharedProps

export function NetlifyIntegrationWizard({
  siteId,
  siteName,
  integration,
  onSetCDNConfig,
  onCancel,
}: NetlifyIntegrationWizardProps) {
  const [step, setStep] = React.useState<FormState>(getInitialStep(integration))

  const handleComplete: CdnIntegrationSharedProps["onSetCDNConfig"] = data => {
    onSetCDNConfig(data)
  }

  return (
    <React.Fragment>
      {step === FormState.Connecting && (
        <ConnectNetlifyForm
          siteId={siteId}
          siteName={siteName}
          onConnected={() => setStep(FormState.New)}
        />
      )}

      {step === FormState.New && (
        <NewNetlifyIntegrationForm
          siteId={siteId}
          onComplete={handleComplete}
          onSwitchToExisting={() => setStep(FormState.Existing)}
          onCancel={onCancel}
        />
      )}

      {step === FormState.Existing && (
        <ExistingNetlifyIntegrationForm
          siteId={siteId}
          onComplete={handleComplete}
          initialNetlifySiteId={integration?.config?.serviceId}
          initialSiteName={integration?.config?.serviceName}
          initialAccount={integration?.config?.accountName}
          onSwitchToNew={() => setStep(FormState.New)}
          onCancel={onCancel}
        />
      )}
    </React.Fragment>
  )
}
